import { apiEndpoint }              from "config/config";
import { AuthContextType, useAuth } from "auth/AuthProvider";

export class ApiError extends Error {
    code: number;
    constructor(code: number, message: string) {
        super(message);
        this.code = code;
    }

    static async fromResponse(response: Response): Promise<ApiError> {
        let code = response.status;
        let message = await response.text();
        try {
            const data = JSON.parse(message);
            code = data.code;
            message = data.message;
        } catch(_) {
            // Well.. do nothing here...
        }
        return new ApiError(code, message);
    }
}

export function HttpClient() {

    const auth: AuthContextType = useAuth();
    return {
        get: async <T>(path: string, params?: Record<string, any>): Promise<T> => {
            if (!path.startsWith('/')) {
                path = '/' + path;
            }
            const queryString = params ? '?' + new URLSearchParams(params).toString() : '';
            const response = await fetch(`${apiEndpoint}${path}${queryString}`, {
                headers: {
                    'Authorization': auth.session ? `${auth.session.token}` : '',
                }
            });
            if (!response.ok) {
                throw await ApiError.fromResponse(response);
            }
            return response.json();
        },
        post: async <T>(path: string, body: FormData|Record<string, any>): Promise<T> => {
            if (!path.startsWith('/')) {
                path = '/' + path;
            }
            const isFormData = body instanceof FormData;
            const headers: Record<string, string> = {
                'Authorization': auth.session ? `${auth.session.token}` : '',
            };
            if (!isFormData) {
                headers['Content-Type'] = 'application/json';
            }
            const response = await fetch(`${apiEndpoint}${path}`, {
                method: 'POST',
                headers,
                body: isFormData ? body : JSON.stringify(body),
            });
            if (!response.ok) {
                throw await ApiError.fromResponse(response);
            }
            return response.json();
        },
        put: async <T>(path: string, body: Record<string, any>): Promise<T> => {
            if (!path.startsWith('/')) {
                path = '/' + path;
            }
            const response = await fetch(`${apiEndpoint}${path}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': auth.session ? `${auth.session.token}` : '',
                },
                body: JSON.stringify(body),
            });
            if (!response.ok) {
                throw await ApiError.fromResponse(response);
            }
            return response.json();
        },
        delete: async <T>(path: string): Promise<T> => {
            if (!path.startsWith('/')) {
                path = '/' + path;
            }
            const response = await fetch(`${apiEndpoint}${path}`, {
                method: 'DELETE',
                headers: {
                    'Authorization': auth.session ? `${auth.session.token}` : '',
                }
            });
            if (!response.ok) {
                throw await ApiError.fromResponse(response);
            }
            return response.json();
        }
    } 
}
